export default {
    noProgram: {
        title: "Ningún programa disponible",
        description: "Este establecimiento no tiene un programa de beneficios activo en este momento.",
    },
    notFound: {
        title: "Establecimiento no disponible",
        description: "Verifica que el enlace sea correcto.",
    },
    error: {
        title: "No se pudo cargar",
        description: "Verifica tu conexión e inténtalo de nuevo.",
        retry: "Intentar de nuevo",
    },
};
